import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { Link as ScrollLink } from 'react-scroll';

export default function Navigation() {
  const { setLang, content } = useContext(LanguageContext);

  return (
<nav className="flex justify-between items-center px-4 md:px-8 py-4 text-white w-full overflow-hidden" style={{ background: "#091c29" }}>      <h1
        className="text-xl font-bold cursor-pointer"
        onClick={() => setLang('en')}
      >
        {content.nav.logo}
      </h1>

      {/* LINKS + FLAGS */}
      <div className="flex items-center gap-4">
        {content.nav.links.map((link, i) => (
          <ScrollLink
            key={i}
            to={link.to}
            smooth
            className="cursor-pointer hover:text-indigo-400"
          >
            {link.text}
          </ScrollLink>
        ))}

       <div className="flex gap-2 ml-7">
        {['ar', 'en', 'fr', 'tr', 'it'].map((lng) => (
          <button
            key={lng}
            onClick={() => setLang(lng)}
            className="w-6 h-6"
          >
            <img
              src={`/assets/flags/${lng}.webp`}
              alt={lng}
              className="w-full h-full rounded-full"
            />
          </button>
        ))}
      </div>
      </div>
    </nav>
  );
}
